<div class="no-scroll container-custom">
  <div class="row d-flex justify-content-center flex-row flex-nowrap">
    <div class="col-md-12">
      <div
        id="carouselExample"
        class="carousel slide"
        data-ride="carousel"
        (mousedown)="onDragStart($event)"
        (mouseup)="onDragEnd($event)"
        (mousemove)="onDrag($event)"
        style="cursor: pointer"
      >
        <div class="carousel-inner carousel-container">
          <div
            #carouselTrack
            class="row d-flex flex-row flex-nowrap justify-content-center articles carousel-track"
            [ngStyle]="{ transform: 'translateX(' + translateX + 'px)' }"
          >
            <div
              *ngFor="let article of articlesSliced"
              class="articleCard carousel-item active"
              (click)="onClickArticle(article.id)"
            >
              <div class="row">
                <div class="col-md-12">
                  <img
                    src="../../../assets/images/placeholder.svg"
                    draggable="false"
                    style="
                      width: 100% !important;
                      min-width: 300px;
                      border-radius: 10px;
                    "
                  />
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <p class="textSmBold colorNeutral700">
                    {{ article?.author
                    }}<span class="textSmBold colorNeutral500">
                      • {{ article?.createdAt | date }}</span
                    >
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p
                    href="{{ article?.link }}"
                    class="text2XlSemibold colorNeutral800"
                  >
                    {{ article?.title }}
                  </p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <p class="textBaseRegular articleSummary">
                    {{ article?.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row mb-5">
                <div class="col-md-1 ml-5 mt-5">
                    <div class="row">
                        <div class="col">
                            <a class="carousel-control-prev" href="#carouselExample" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="false"></span>
                                <span class="sr-only"></span>
                                <span class="arrowContainer" (click)="carouselGoBack()">
                                    <img src="../../../assets/images/arrow_left.svg">
                                </span>
                            </a>
                        </div>
                        <div class="col">
                            <a class="carousel-control-next" href="#carouselExample" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="false"></span>
                                <span class="sr-only"> </span>
                                <span class="arrowContainer" (click)="carouselGoForward()">
                                    <img src="../../../assets/images/arrow_right.svg">
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div> -->
    </div>
  </div>
</div>
